import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const legendLabelColor = '#777c83'

const TreeMapChart = ({
    chartData = [],
    chartLabel,
    fieldsLabel = "",
    purpose = "",
    legendLabel = "Dormant Tasks",
}) => {


    const graphData =
        chartData.length > 0
            ? chartData
            : [];

    const colors = [
        "#3B82F6",
        "#10B981",
        "#F59E0B",
        "#EF4444",
        "#8B5CF6",
        "#06B6D4",
    ];

    const option = {
        tooltip: {
            z: 9999,
            zlevel: 9999,
            appendTo: () => document.body,
            formatter: (params) => {

                const item = params.data;

                return `
            ${purpose ? `<b>Purpose</b><br/>${purpose}<br/><br/>` : ""}

            <b>${item.name}</b><br/>
            <b>Dormant Tasks</b> : ${item.dormantTasks || "N/A"}<br/>
            <b>Estimate Hours</b> : ${item.totalEstimateHours || "N/A"}<br/>
            <b>Actual Hours</b> : ${item.totalActualHours || " N/A"}
        `;
            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            data: [legendLabel],
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        series: [
            {
                name: legendLabel,
                type: "treemap",
                roam: false,
                nodeClick: false,
                breadcrumb: {
                    show: false,
                },
                label: {
                    show: true,
                    color: "#fff",
                    fontSize: 14,
                    fontWeight: "bold",
                    formatter: "{b}",
                },

                upperLabel: {
                    show: false,
                },

                itemStyle: {
                    borderColor: "#fff",
                    borderWidth: 0,
                    gapWidth: 0,
                },

                data: graphData.map((item, index) => ({
                    name: item.projectName,
                    value: item.value,
                    dormantTasks: item.dormantTasks,
                    totalEstimateHours: item.totalEstimateHours,
                    totalActualHours: item.totalActualHours,
                    itemStyle: {
                        color: colors[index % colors.length],
                    },
                })),
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={420}
        >
            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default TreeMapChart;